import React from 'react'
import PropTypes from 'prop-types'
import { ScopeDisplayItem } from './ScopeDisplayItem'

const UserScopeDisplay = ({ name, subTitle, size, hideAvatars }) => {
  return (
    <ScopeDisplayItem
      name={name}
      subTitle={subTitle}
      size={size}
      hideAvatar={hideAvatars}
    />
  )
}

UserScopeDisplay.propTypes = {
  name: PropTypes.string,
  subTitle: PropTypes.string,
  hideAvatars: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg'])
}

export default UserScopeDisplay
